import {gsap} from "gsap";
import {BruteForce} from "../BruteForce";
import {BruteForceGameMode} from "../server/BruteForceGameMode";
import {BruteForceSound} from "../sound/BruteForceSound";
import {BruteForceHelper} from "../utils/BruteForceHelper";


export class BruteForceBonusIntro extends PIXI.Container {

    private _spinsWonNr: PIXI.spine.Spine;
    private _freespinsNameLogo: PIXI.spine.Spine

    constructor() {
        super();
        this.name = "FreespinIntro";
        this.init();
    }

    public hideFSIntro(): gsap.core.Timeline {
        const hideFSIntroTL: gsap.core.Timeline = gsap.timeline();
        hideFSIntroTL.add(() => {
            BruteForce.foregroundElements.playArcadeMachineAnimation("normal", false);
            BruteForce.backgroundElements.setMode(BruteForce.model.nextMode);
            BruteForce.allreelsView.changeReelSet();
        }, 0);
        hideFSIntroTL.to(this, {duration: 0.2, alpha: 0});
        hideFSIntroTL.add(BruteForce.transitionShutter.playDoorOpen(), "<");
        hideFSIntroTL.add(() => {
            BruteForceSound.playTrack(BruteForceSound.DOOR_OPEN);
        }, "<")
        if (BruteForce.model.nextMode === BruteForceGameMode.FREESPIN) {
            hideFSIntroTL.add(BruteForce.backgroundElements.fsintroBgTravel(), ">");
        } else {
            hideFSIntroTL.add(BruteForce.backgroundElements.sfsIntroBgTravel(), ">");
        }
        hideFSIntroTL.add(BruteForce.allreelsView.dropReelSetAnimation(), "<0.9");

        hideFSIntroTL.add(() => {
            BruteForceSound.switchMusic({name: BruteForce.model.nextMode === BruteForceGameMode.FREESPIN ? BruteForceSound.FS_MUSIC : BruteForceSound.SFS_MUSIC});
            this.visible = false;
            BruteForceHelper.resetSpineItem(this._freespinsNameLogo);
            BruteForceHelper.resetSpineItem(this._spinsWonNr);
            BruteForce.transitionShutter.doorVisibility(false);
        });
        return hideFSIntroTL;
    }

    public show(): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();

        this._spinsWonNr.visible = true;
        this._freespinsNameLogo!.visible = true;
        this.visible = true;
        this.alpha = 1;
        BruteForce.anticipationView.closeXBetHighlight();
        BruteForce.transitionShutter.doorVisibility(true);
        BruteForce.gameContainer.resetNudgeMultiplier();


        tl.add(BruteForce.transitionShutter.playDoorClose(), 0);
        tl.add(() => {
            BruteForceSound.playTrack(BruteForceSound.DOOR_CLOSE)
        }, "<")
        tl.add(() => {
            BruteForce.foregroundElements.playArcadeMachineAnimation("fs", true);
            BruteForceSound.switchMusic({name: BruteForceSound.BUNKER_SCREEN_MUSIC});
        }, 0);
        tl.add(BruteForceHelper.playSpineWithTimeline(this._spinsWonNr, 0, "10"), 0.42);
        tl.add(BruteForceHelper.playSpineWithTimeline(this._freespinsNameLogo, 0, BruteForce.model.nextMode === BruteForceGameMode.FREESPIN ? "BruteSpin" : "SuperBruteSpin"), 0.52);
        tl.add(()=>{
            BruteForceSound.playTrack(BruteForce.model.nextMode === BruteForceGameMode.FREESPIN ? BruteForceSound.SHINY_BRUTE : BruteForceSound.SHINY_SUPER_BRUTE);
        },"<")
        tl.add(() => {
            BruteForce.transitionShutter.doorAnimationLoop();
            this._freespinsNameLogo.autoUpdate = true;
            this._freespinsNameLogo.state.setAnimation(0,BruteForce.model.nextMode === BruteForceGameMode.FREESPIN?"BruteSpin_loop":"SuperBruteSpin_loop" , true);
        }, tl.duration());
        return tl;
    }

    private init(): void {

        this.visible = false;


        this._spinsWonNr = new PIXI.spine.Spine(BruteForce.assetLoader.getSpineAsset("bonusIntroText"));
        this._spinsWonNr.visible = false;
        this._spinsWonNr.position.set(360, 300);
        this._spinsWonNr.name = "10 no image";
        this.addChild(this._spinsWonNr);


        this._freespinsNameLogo = new PIXI.spine.Spine(BruteForce.assetLoader.getSpineAsset("bonusIntroText"));
        this._freespinsNameLogo.visible = false;
        this._freespinsNameLogo.position.set(360 - this._freespinsNameLogo.width * 0.5, 440);
        this._freespinsNameLogo.name = "spinsLOGO";
        this.addChild(this._freespinsNameLogo);
    }
}